export { StoreFaqs } from "./store-faqs";
